import { beginQuickbooksAuth } from "./functions"

const api = {
    async linkQuickbooks(popupInstance: Window | null) {
        const {data: url} = await beginQuickbooksAuth();
        
        if(!popupInstance) throw new Error("Popup failed");
        popupInstance.location.href = url;

        await new Promise<void>((res, rej) => {
            const interval = setInterval(() => {
                if(popupInstance.closed) {
                    clearInterval(interval);
                    res();
                }
            })
        });
    }
}

export default api;